export default {
    name: null,
    streetAddress: null,
    city: null,
    state: null,
    zip: null,
    fein: null,
    entityType: null,
    yearsInBusiness: null,
    otherInfo: null,
    inspectionContact: {
        name: null,
        phone: null,
        email: null,
    },
    accountingContact: {
        name: null,
        phone: null,
        email: null,
    },
    claimsContact: {
        name: null,
        phone: null,
        email: null,
    }
};
